import React from "react";

const InputError = (props) => {
    return (
        <span style={{fontSize:'13px' ,color:'red',display: props.show ? 'block' :'none' ,padding:5}} className="pl-0 pb-0 error-message">{props.message}</span>
    );
}

export default InputError;
